import React, { Component } from 'react'
import {Container,  Row, Col } from 'reactstrap';

//css
import './SectionPrincipal.scss';

//import svg
import Backing from './backing/backing';
import Stand from './stand/stand';
import Impresion from './impresion/impresion';

class Section extends Component {

  constructor(props){
    super(props);
    this.state ={
      // shoeImage:true
    }
  }
  render() {
    return (
    <div className={"SectionPrincipal"} >
        <Container>
          <Row>
            <Col lg="4" md="4" sm="6" xs="12" >
              <Backing/>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12"  >
              <Stand/>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" >
              {/* <Impresion/> */}
            </Col>
            <Col>
            <div className="next">
              <i className="fas fa-arrow-down"></i>
            </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}
export default Section;



// WEBPACK FOOTER //
// ./src/Components/Section-Principal/SectionPrincipal.jsx